<template>
  <div class="applicationList div-layout">
    <div
      v-show="!hiddenVariable.dialogEditVisible && !hiddenVariable.dialogVersionVisible"
      class="applicationList-main"
    >
      <module-title title="应用管理">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit"
          >
            添加应用
          </el-button>
        </div>
      </module-title>
      <div class="applicationList-main-contain">
        <el-form
          ref="searchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
          @submit.native.prevent
        >
          <div class="query">
            <el-form-item label="应用名称">
              <el-input
                v-model="searchForm.name"
                name="name"
                maxlength="10"
                placeholder="请输入应用名称"
                style="width:300px"
                @keyup.enter.native="handleSearchFilter"
              />
            </el-form-item>
            <el-form-item label="应用类型">
              <el-select v-model="appType" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="medium" @click="reset">
                重置
              </el-button>
            </el-form-item>
          </div>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="applicationList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column label="应用名称" prop="name" align="left" />
          <el-table-column
            label="应用类型"
            prop="appType"
            align="left"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.appType === 0" class="text-center">
                课堂活动应用
              </div>
              <div v-if="scope.row.appType === 1" class="text-center">
                系统内置应用
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="版本号"
            prop="versionName"
            align="left"
          />
          <el-table-column
            label="应用大小"
            prop="fileSize"
            align="left"
          />
          <el-table-column
            label="创建时间"
            prop="createDate"
            align="left"
            show-overflow-tooltip
          />
          <el-table-column label="操作" align="left" width="300px">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="small"
                icon="el-icon-info"
                @click="viewApplicationDetail(scope.row)"
              >
                查看
              </el-button>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-link"
                @click="gotoVersion(scope.row)"
              >
                版本
              </el-button>
              <el-button
                type="primary"
                size="small"
                command="a"
                @click="handleCommand(scope.row)"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <add-application
      v-if="hiddenVariable.dialogEditVisible"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :handle-type="handleType"
      :application-detail="applicationDetail"
      @onSuccess="fetchApplicationList"
    />
    <version-manage
      v-if="hiddenVariable.dialogVersionVisible"
      :visible.sync="hiddenVariable.dialogVersionVisible"
      :app-id="handleAppId"
      :app-name="appName"
      @onSuccess="fetchApplicationList"
    />
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogDetailVisible"
      title="应用详情"
      width="650px"
    >
      <div class="manager-info">
        <ul>
          <li>
            <label for>应用名称：</label>
            {{ applicationDetail.name }}
          </li>
          <li>
            <label for>应用编码：</label>
            {{ applicationDetail.code }}
          </li>
          <li class="app-info">
            <label for>应用详情：</label>
            <div v-html="applicationDetail.appDetail" />
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import AddApplication from './addApplication';
import VersionManage from './versionManage';
import {
  appList
} from '@/api/productOperation/classRoom/applicationList';
import { mapGetters } from 'vuex';
export default {
  name: 'ClassApplicationList',
  components: {
    AddApplication,
    VersionManage
  },
  data() {
    return {
      // 弹框标题
      options: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '课堂活动应用'
        }, {
          value: '1',
          label: '系统内置应用'
        }],
      appType: '',
      appName: '', // 应用名称
      handleType: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        // 详情
        dialogDetailVisible: false, // 详情标识
        // 版本管理
        dialogVersionVisible: false
      },
      stageArr: [],
      // 搜索表单
      searchForm: {
        name: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      handleAppId: '',
      listLoading: false, // 表格刷新loading
      applicationList: [],
      applicationDetail: {}
    };
  },
  computed: {
    ...mapGetters(['currentProdeuctId'])
  },
  mounted() {
    this.fetchApplicationList();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    reset() {
      this.searchForm.name = '';
      this.appType = '';
      this.fetchApplicationList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchApplicationList();
    },
    // 打开新增编辑弹框
    opAddOrEdit() {
      this.handleType = 'add';
      this.hiddenVariable.dialogEditVisible = true;
    },
    gotoVersion(row) {
      this.appName = row.name;
      this.handleAppId = row.id;
      this.hiddenVariable.dialogVersionVisible = true;
    },
    // 查看详情
    viewApplicationDetail(row) {
      this.applicationDetail = row;
      this.hiddenVariable.dialogDetailVisible = true;
    },
    // 更多下拉菜单点击事件
    handleCommand(row) {
      this.handleType = 'edit';
      this.applicationDetail = row;
      this.hiddenVariable.dialogEditVisible = true;
    },
    // 获取应用列表
    fetchApplicationList() {
      this.listLoading = true;
      const data = {
        appType: this.appType,
        name: this.searchForm.name,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        typeCode: 'B12'
      };
      appList(data)
        .then((result) => {
          this.applicationList = result.data.list;
          this.applicationList.map(item => {
            item.fileSize = (item.fileSize / (1024 * 1000)).toFixed(1) + 'MB';
          });
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.applicationList {
  padding-bottom: 20px;
}
.handle-form-input {
  width: 150px;
}
.moreBtn {
  margin-left: 10px;
}
.newtip {
  font-style: normal;
  color: #fff;
  background: red;
  margin-left: 5px;
}
.manager-info {
  display: flex;
  ul {
    margin-left: 60px;
    width: 100%;
    min-width: 220px;
    li {
      label {
        margin-right: 10px;
      }
      margin-bottom: 20px;
      .intro-picture {
        display: inline-block;
        img {
          vertical-align: text-top;
          width: 100px;
          height: 100px;
          margin-right: 10px;
        }
      }
      .logo-detail {
        vertical-align: text-top;
        width: 100px;
        height: 100px;
      }
    }
  }
}
.query {
  display: flex;
  margin-left: -22px;
}
/deep/.query button {
  margin-left: 15px;
}
.app-info{
  display:flex;
}
.app-info div{
  line-height: 1.5;
}
</style>
